/* eslint-disable react/prop-types */
import React from 'react';
import { useFormikContext } from 'formik';

import CustomerClusterSearch from '@components/form/search/CustomerClusterSearch';
import SociollaErrorMessage from './SociollaErrorMessage';

function SociollaCustomerClusterSearch({ name, onChange, ...otherProps }) {
  const { setFieldValue, errors, touched, values } = useFormikContext();

  return (
    <>
      <CustomerClusterSearch
        onChange={async (value) => {
          await setFieldValue(name, value);
          if (onChange) {
            onChange(value);
          }
        }}
        value={values[name]}
        {...otherProps}
      />
      <SociollaErrorMessage error={errors[name]} visible={touched[name]} />
    </>
  );
}

export default SociollaCustomerClusterSearch;
